module.exports = __webpack_public_path__ + "static/media/audiobook.515f9b37.jpg";